export const SettingsType = {
  BOOLEAN: 1,
  TEXT: 2,
  JOBJECT: 3,
  JARRAY: 4
}